import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'
import Get from './views/Get.vue'

export const EmployeesRoutes = [
  {
    path: '/employees',
    name: 'ListEmployees',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'employee:list'
    }
  },
  {
    path: '/employee',
    name: 'CreateEmployee',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'employee:create'
    }
  },
  {
    path: '/employee/:id',
    name: 'UpdateEmployee',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'employee:update'
    }
  },
  {
    path: '/employee/view/:id',
    name: 'GetEmployee',
    component: Get,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'employee:get'
    }
  }
]
